import type { VisibilityOnPagesSettingsType } from '../types';

export function getVisibilityOnPageSettings<T>(
  settings?: Extract<T, VisibilityOnPagesSettingsType>
): VisibilityOnPagesSettingsType | null {
  if (!settings) {
    return null;
  }
  const {
    visibilityOnPagesDisplayMode = 'allPages',
    visibilityOnPagesDisplayPages = [],
    visibilityOnPagesHideMode = 'none',
    visibilityOnPagesHidePages = []
  } = settings;

  return {
    visibilityOnPagesDisplayMode,
    visibilityOnPagesDisplayPages,
    visibilityOnPagesHideMode,
    visibilityOnPagesHidePages
  };
}
